/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValuePerBinderDetailResponseDto
 */
export interface ValuePerBinderDetailResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof ValuePerBinderDetailResponseDto
     */
    isExceeded: boolean;
    /**
     * 
     * @type {string}
     * @memberof ValuePerBinderDetailResponseDto
     */
    value: string;
}

/**
 * Check if a given object implements the ValuePerBinderDetailResponseDto interface.
 */
export function instanceOfValuePerBinderDetailResponseDto(value: object): value is ValuePerBinderDetailResponseDto {
    if (!('isExceeded' in value) || value['isExceeded'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function ValuePerBinderDetailResponseDtoFromJSON(json: any): ValuePerBinderDetailResponseDto {
    return ValuePerBinderDetailResponseDtoFromJSONTyped(json, false);
}

export function ValuePerBinderDetailResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValuePerBinderDetailResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'isExceeded': json['isExceeded'],
        'value': json['value'],
    };
}

export function ValuePerBinderDetailResponseDtoToJSON(json: any): ValuePerBinderDetailResponseDto {
    return ValuePerBinderDetailResponseDtoToJSONTyped(json, false);
}

export function ValuePerBinderDetailResponseDtoToJSONTyped(value?: ValuePerBinderDetailResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isExceeded': value['isExceeded'],
        'value': value['value'],
    };
}

